"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Errors = {
    SRC_PARSE: 'error-src-parse',
    MANIFEST_LOAD: 'error-manifest-load',
    MANIFEST_PARSE: 'error-manifest-parse',
    MANIFEST_INCOMPATIBLE: 'error-manifest-incompatible',
    LEVEL_LOAD: 'error-level-load',
    CONTENT_LOAD: 'error-content-load',
    CONTENT_PARSE: 'error-content-parse',
    MEDIA: 'error-media',
    UNKNOWN: 'error-unknown',
};
exports.default = Errors;
//# sourceMappingURL=errors.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/playable/dist/src/constants/errors.js
// module id = 52
// module chunks = 0